module.exports = __webpack_public_path__ + "media/images/remittees_3-f6d7f585ede3b163ec0a3b177ca41359.jpg";